import { ReactNode } from "react";
import { Tag as CommonTag, TagProps as CommonTagProps } from "capitalrx-components-2.0/lib/general";

import styles from "./styles.module.scss";

export interface TagProps extends CommonTagProps {
  children: ReactNode;
}

export const Tag = (props: TagProps) => {
  const { children } = props;
  return (
    <CommonTag {...props} className={styles["Tag"]}>
      {children}
    </CommonTag>
  );
};
